import { CommonModule } from '@angular/common';
import { Component, computed, contentChild, input, output, type TemplateRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from '@sb/tooltip';
import { BadgeComponent } from '@sb/ui/badge';
import { DividerDirective } from '@sb/ui/divider';
import { IconComponent } from '@sb/ui/icon';

@Component({
  selector: 'sb-plan-card',
  imports: [CommonModule, IconComponent, BadgeComponent, TooltipDirective, TranslatePipe, DividerDirective],
  templateUrl: './plan-card.component.html',
  host: {
    '(click)': 'onClick()',
  },
})
export class PlanCardComponent {
  name = input<string>();
  tagline = input<string>();

  inTrial = input(false);
  selected = input(false);
  disabled = input(false);
  isCurrent = input(false);
  mostPopular = input(false);
  isFree = input(false);
  trialGranted = input(false);
  trialExpired = input(false);
  isLegacyPlan = input(false);
  displayPrice = input<string>();
  minOrderQuantity = input<number>();

  featureTitle = input<string>();
  features = input<string[]>([]);
  featureParams = input<Record<string, unknown>>({});

  brandColor = input<'primary' | 'green'>('primary');
  display = input<'vertical' | 'horizontal'>('vertical');
  useNewPricingStructure = input<boolean>();
  additionalEmployeeCost = input<{ cost: string; costText: string; billingPeriod: string }>();
  selectPlan = output<void>();

  disabledTooltip = contentChild<TemplateRef<unknown>>('disabledTooltip');

  clickable = computed(() => !this.disabled() && !this.selected());

  isVertical = computed(() => this.display() === 'vertical');

  showTrialBadge = computed(
    () => !this.isFree() && !this.trialGranted() && !this.trialExpired() && !this.isLegacyPlan(),
  );

  onClick(): void {
    if (!this.clickable()) {
      return;
    }
    this.selectPlan.emit();
  }
}
